import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        iconboxCard: {
            gap: remCalc(16),
            justifyContent: 'center',
            alignContent: 'center',
            flexGrow: 1,
            flexBasis: 0,
            maxWidth: {base: remCalc(151), md: remCalc(240)},
            paddingX: remCalc(20),
        },
        icon: {
            height: 'iconsSize.xlarge',
            width: 'iconsSize.xlarge',
            margin: 'auto',
        },
        contentWrapper: {
            flexDirection: 'column',
            justifyContent: 'center',
        },
        title: {
            textStyle: 'body-medium',
            marginBottom: remCalc(4),
        },
        subtitle: {
            textStyle: 'body-xsmall',
            color: 'text.secondary',
        },
        sectionContainer: {
            direction: 'column',
            alignItems: 'center',
            textAlign: 'center',
            gap: {base: remCalc(40), md: remCalc(60)},
            paddingX: remCalc(16),
            paddingBottom: {base: remCalc(40), lg: remCalc(0)},
            margin: '0 auto',
            w: '100%',
            maxWidth: remCalc(1400),
        },
        sectionTitle: {
            textStyle: 'head-large',
            fontWeight: 'medium',
        },
        cardsWrapper: {
            direction: 'column',
            gap: remCalc(24),
            width: '100%',
        },
        cardsRow: {
            gap: {md: remCalc(20)},
            justifyContent: {base: 'space-evenly', md: 'space-between'},
            width: '100%',
        },
        separator: {
            width: remCalc(1),
            height: {md: remCalc(110)},
            backgroundColor: 'border.light',
            alignSelf: {base: 'stretch', md: 'center'},
        },
        emptySpace: {
            flexGrow: 1,
            flexBasis: 0,
            maxWidth: {base: remCalc(151), md: '100%'},
        },
        actionButton: {
            maxWidth: {md: remCalc(332)},
            width: '100%',
        },
        ctaLinks: {
            textStyle: 'body-xsmall',
            fontWeight: 'bold',
        },
    },
    variants: {},
}
